import { InfoButton } from './InfoModal';

/**
 * Worker option Infos on the building form.
 * Titles stay English keys so INFO_CATALOG can localize body + modal title.
 */
export function WorkerMarkersInfoButton({ className = '' }) {
  return (
    <InfoButton title="Worker floor-plan markers" className={className}>
      <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
        <p>
          When <strong>ON</strong>, field workers may <strong>drag unit number markers</strong> on the app floor plan to
          correct placement when the drawn position does not match the site.
        </p>
        <p>
          Moves are allowed <strong>only for jobs assigned to that worker</strong> on this building — not for every
          building in the portfolio.
        </p>
        <p>
          Every move is logged: previous position, new position, reason, worker, role, and date (audit trail for later
          review).
        </p>
        <p>
          When <strong>OFF</strong>, markers stay fixed as set in the office (web Floor plan). Workers can still view the
          plan and inspect units; they cannot reposition markers.
        </p>
        <p className="text-gray-500">
          Turn ON for sites where layout often changes or first-time floor-plan setup needs field correction. Leave OFF
          when the office plan is the sole source of truth.
        </p>
      </div>
    </InfoButton>
  );
}

export function DefaultBuildingInfoButton({ className = '' }) {
  return (
    <InfoButton title="Default building for workers" className={className}>
      <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
        <p>
          When <strong>ON</strong>, this building pack can be <strong>downloaded to every worker&apos;s app</strong>{' '}
          without a personal building assignment. Useful for demo sites, training, or a shared practice building.
        </p>
        <p>
          When <strong>OFF</strong> (normal production), workers only receive buildings they are assigned to (or that
          appear on their jobs). That keeps the app focused on their real workload.
        </p>
        <p>
          <strong>Master / Admin</strong> accounts already see all buildings in the office tools; this checkbox mainly
          affects <strong>field worker</strong> app download lists.
        </p>
        <p className="text-gray-500">
          Do not enable on every live customer building — prefer assignment-based access. Use sparingly for demo or shared
          practice sites only.
        </p>
      </div>
    </InfoButton>
  );
}
